import React from 'react'
import { StyledCaret } from './styles'

interface CaretDownIconProps {
  flipped?: boolean
}

const CaretDownIcon: React.FC<CaretDownIconProps> = ({ flipped = false }) => {
  return (
    <StyledCaret
      className="icon--caret-down"
      flipped={flipped}
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="7"
      viewBox="0 0 12 7"
      fill="none"
    >
      <path
        d="M5.99998 6.84035C5.78492 6.84035 5.56988 6.75824 5.40591 6.59435L0.24617 1.43456C-0.0820567 1.10633 -0.0820567 0.574165 0.24617 0.246071C0.574264 -0.0820235 1.10632 -0.0820235 1.43458 0.246071L5.99998 4.81174L10.5654 0.24623C10.8936 -0.0818641 11.4256 -0.0818641 11.7537 0.24623C12.0821 0.574324 12.0821 1.10649 11.7537 1.43471L6.59405 6.59451C6.43 6.75842 6.21496 6.84035 5.99998 6.84035Z"
        fill="currentColor"
      />
    </StyledCaret>
  )
}

export default CaretDownIcon
